import React, { useLayoutEffect, useRef, useState } from 'react';
import { SecondaryButtonInline } from '../../../components';
import css from './SectionDescription.module.css';
import { MAX_MOBILE_SCREEN_WIDTH } from '../../ProfilePage/ProfilePage';
import CustomisedDialog from '../../../components/Dialog/Dialog';
import { DialogContent, DialogTitle } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Text } from '@chakra-ui/react';
import { isNil, trim } from 'lodash';

const LINE_CLAMP = 3;

const SectionDescriptionMaybe = ({ title, description }) => {
  const textRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const computed = window.getComputedStyle(el);
    const lineHeight = parseFloat(computed.lineHeight);

    requestAnimationFrame(() => {
      const lines = el.scrollHeight / lineHeight;

      setIsEllipsisActive(Math.round(lines) > LINE_CLAMP);
    });
  }, [description]);

  if (isNil(description)) {
    return null;
  }

  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;

  const isMobileLayout = hasMatchMedia
    ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
    : true;

  const onClose = () => setIsModalOpen(false);

  return (
    <section className={css.sectionDescription}>
      <CustomisedDialog
        open={isModalOpen}
        fullScreen={isMobileLayout}
        fullWidth
        className={css.listingDescriptionModal}
        onClose={onClose}
      >
        <div className={css.modalCloseButtonContainer}>
          <CloseRoundedIcon onClick={onClose} />
        </div>
        <DialogTitle>
          <Text fontWeight="semibold" textStyle="xl" color={'almostBlack'} m={0}>
            {title}
          </Text>
        </DialogTitle>
        <DialogContent>
          <Text whiteSpace="pre-line" color={'almostBlack'}>
            {description}
          </Text>
        </DialogContent>
      </CustomisedDialog>

      <h2 className={css.sectionHeading}>{title}</h2>
      <Text ref={textRef} lineClamp={LINE_CLAMP} whiteSpace="pre-line">
        {trim(description)}
      </Text>
      {isEllipsisActive && (
        <SecondaryButtonInline className={css.showMoreButton} onClick={() => setIsModalOpen(true)}>
          Show more
        </SecondaryButtonInline>
      )}
    </section>
  );
};

export default SectionDescriptionMaybe;
